import React, { useEffect, useState, useRef } from "react";
import FullCalendar from "@fullcalendar/react"; // must go before plugins
import timeGridPlugin from "@fullcalendar/timegrid";
import es from "@fullcalendar/core/locales/es";
import "./Horario.css";
import "./Events";
import useProcesoMatricula from "../../hooks/useProcesoMatricula";
import useAuth from "../../hooks/useAuth";
import { Tooltip } from "bootstrap";
import useMatricula from "../../hooks/useMatricula";

export default function HorarioPanel() {
  const calendarRef = useRef(null);
  const [eventoss, setEventoss] = useState([]);


  const { seleccionIdiomas, listadoIdiomas } = useAuth();
  const [idioma, setIdioma] = useState("es");
  const [fechaCalendar, setFechaCalendar] = useState({
    startRecur: "",
    endRecur: "",
  });



  let { listEventos, setErrorCursoServices } = useProcesoMatricula();
  const { gruposHabilitados } = useMatricula();

  let tooltipInstance = null;

  const [selectMonth, setSelectMonth] = useState("");
  const [selectYear, setSelectYear] = useState("");

  const [dateInitial, setDateInitial] = useState("");

  useEffect(() => {
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      // Realizar acciones después de que el calendario se haya montado
      // Obtiene la fecha actual
      const currentDate = calendarApi.getDate();

      // Obtiene el mes y el año actual
      var language = idioma;
      const monthNames = currentDate.toLocaleString(language, {
        month: "long",
      });
      const capitalizedMonth =
        monthNames.charAt(0).toUpperCase() + monthNames.slice(1);
      const currentMonth = currentDate.getMonth() + 1;
      const currentYear = currentDate.getFullYear();
    }
  }, []);

  useEffect(() => {
    if (fechaCalendar?.startRecur) {
      selectDefaultMonth();
      selectDefaultYear();
      setDateInitial(fechaCalendar?.startRecur);
    }
  }, [fechaCalendar]);

  useEffect(() => {
    let datas = listadoIdiomas.map((e) => {
      if (e.cidioma == seleccionIdiomas) {
        return e.dsigla;
      }
    });
    setIdioma(String(datas).replace(",", ""));
  }, [fechaCalendar]);

  function sumarDiasFinFullCalendar(fecha, dias) {
    let dataFinal = new Date(fecha).setDate(new Date(fecha).getDate() + dias);
    return dataFinal;
  }

  useEffect(() => {
    let menorDiaIncio = gruposHabilitados[0]?.finicio;
    let mayorDiaFin = gruposHabilitados[0]?.ffin;
    gruposHabilitados.map((data) => {
      if (
        new Date(data.finicio).getTime() < new Date(menorDiaIncio).getTime()
      ) {
        menorDiaIncio = data.finicio;
      }

      if (new Date(data.ffin).getTime() > new Date(mayorDiaFin).getTime()) {
        mayorDiaFin = data.ffin;
      }
    });
    setFechaCalendar({
      startRecur: menorDiaIncio,
      endRecur: new Date(sumarDiasFinFullCalendar(mayorDiaFin, 1)),
    });
  }, [gruposHabilitados]);

  const handleMouseEnter = (info) => {
    if (info.event.extendedProps.description) {
      tooltipInstance = new Tooltip(info.el, {
        title: info.event.extendedProps.description,
        html: true,
        placement: "top",
        trigger: "hover",
        container: "body",
      });

      tooltipInstance.show();
    }
  };
  const handleMouseLeave = (info) => {

    if (tooltipInstance) {
      tooltipInstance.dispose();
      tooltipInstance = null;
      document.querySelector(".tooltip.show")?.remove();
    }
  };

  const retornaNombreMes = (mes) => {
    let nombreMes = "";

    if (idioma == "es") {
      switch (mes) {
        case 1:
          nombreMes = "enero";
          break;
        case 2:
          nombreMes = "febrero";
          break;
        case 3:
          nombreMes = "marzo";
          break;
        case 4:
          nombreMes = "abril";
          break;
        case 5:
          nombreMes = "mayo";
          break;
        case 6:
          nombreMes = "junio";
          break;
        case 7:
          nombreMes = "julio";
          break;
        case 8:
          nombreMes = "agosto";
          break;
        case 9:
          nombreMes = "septiembre";
          break;
        case 10:
          nombreMes = "octubre";
          break;
        case 11:
          nombreMes = "noviembre";
          break;

        default:
          nombreMes = "diciembre";
          break;
      }
    }
    if (idioma == "en") {
      switch (mes) {
        case 1:
          nombreMes = "January";
          break;
        case 2:
          nombreMes = "February	";
          break;
        case 3:
          nombreMes = "March";
          break;
        case 4:
          nombreMes = "April";
          break;
        case 5:
          nombreMes = "May";
          break;
        case 6:
          nombreMes = "June";
          break;
        case 7:
          nombreMes = "July";
          break;
        case 8:
          nombreMes = "August";
          break;
        case 9:
          nombreMes = "September";
          break;
        case 10:
          nombreMes = "October";
          break;
        case 11:
          nombreMes = "November";
          break;

        default:
          nombreMes = "December";
          break;
      }
    }

    return nombreMes.toUpperCase();
  };
  const formatearFechaCabecera = (data) => {
    let convFecha = new Date(`${data.endStr}`);

    var cmonth = retornaNombreMes(convFecha.getMonth() + 1);

    var cyear = +convFecha.getFullYear();

    let refernciaMes = document.querySelector(".fc .fc-toolbar-title");
    if (refernciaMes) {
      refernciaMes.innerHTML = `
       
        <button class="fc-cmonth-button fc-button fc-button-primary">
          <p class="mb-0 text-uppercase pt-1">${cmonth} ${cyear}</p>
        </button>
       
        `;
    }

    const buttonElementYear = document.querySelector(".fc-yearButtons-button"); // Obtén el elemento del botón por su ID

    if (buttonElementYear) {
      buttonElementYear.removeAttribute("title"); // Elimina el atributo 'title' del elemento
    }

    const buttonElementMonth = document.querySelector(
      ".fc-monthButtons-button"
    );

    if (buttonElementMonth) {
      buttonElementMonth.removeAttribute("title");
    }
  };

  const getYearsInRange = () => {
    const startDate = new Date(fechaCalendar.startRecur);
    const endDate = new Date(fechaCalendar.endRecur);
    endDate.setDate(endDate.getDate() - 1); // Restar 1 día

    const years = [];
    let currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      years.push(currentDate.getFullYear());
      currentDate.setFullYear(currentDate.getFullYear() + 1);
    }

    return years;
  };

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  const getMonthNames = () => {
    let language = idioma;

    let months = [];
    for (let month = 0; month < 12; month++) {
      let monthName = new Intl.DateTimeFormat(language, {
        month: "long",
      }).format(new Date(2000, month, 1));
      monthName = capitalizeFirstLetter(monthName);
      months.push({ monthName: monthName, monthNumber: month + 1 });
    }
    return months;
  };

  const selectDefaultMonth = () => {
    const currentDate = new Date(fechaCalendar.startRecur);
    setSelectMonth(Number(currentDate.getMonth() + 1));
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const selectDefaultYear = () => {
    let valorYear = new Date(fechaCalendar?.startRecur).getFullYear();
    setSelectYear(valorYear);
  };

  const handleMonthChange = (valorMonth) => {
    const calendarApi = calendarRef.current.getApi();


    let DateStartRecur = new Date(fechaCalendar.startRecur);
    const month = String(DateStartRecur.getMonth() + 1);

    const day = String(DateStartRecur.getDate());

    let dateToGo = `${selectYear}-${valorMonth < 10 ? "0" + valorMonth : valorMonth
      }-${month == valorMonth ? day.padStart(2, "0") : "01"}`;

    if (
      dateToGo >= formatDate(fechaCalendar.startRecur) &&
      dateToGo <= formatDate(fechaCalendar.endRecur)
    ) {
      calendarApi.gotoDate(String(dateToGo));
      setSelectMonth(valorMonth);
    } else {
      let modalErrorr = document.querySelector("#modalErr");

      if (modalErrorr) {
        modalErrorr.click();
        let msgParrafo = `El año y mes seleccionado debe estar en el rango de "${formatDate(
          fechaCalendar.startRecur
        )}" al "${formatDate(fechaCalendar.endRecur)}"`;
        setErrorCursoServices(`SELECCIÓN NO VÁLIDA|${msgParrafo}`);
      }
    }
  };

  const handleYearChange = (valueYear) => {
    const calendarApi = calendarRef.current.getApi();

    // Esta seccion es solamente es de la fecha de inicio Valida
    let DateStartRecur = new Date(fechaCalendar.startRecur);
    const month = String(DateStartRecur.getMonth() + 1);

    const day = String(DateStartRecur.getDate());

    let dateToGo = `${valueYear}-${selectMonth < 10 ? "0" + selectMonth : selectMonth
      }-${month == selectMonth ? day.padStart(2, "0") : "01"}`;

    if (
      dateToGo >= formatDate(fechaCalendar.startRecur) &&
      dateToGo <= formatDate(fechaCalendar.endRecur)
    ) {
      calendarApi.gotoDate(String(dateToGo));
      setSelectYear(valueYear);
    } else {
      let modalErrorr = document.querySelector("#modalErr");

      if (modalErrorr) {
        modalErrorr.click();
        let msgParrafo = `El año y mes seleccionado debe estar en el rango de "${formatDate(
          fechaCalendar.startRecur
        )}" al "${formatDate(fechaCalendar.endRecur)}"`;
        setErrorCursoServices(`SELECCIÓN NO VÁLIDA|${msgParrafo}`);
      }
    }
  };

  const { startRecur } = fechaCalendar;
  if (startRecur) {
    return (
      <div className="calendarioCustems" style={{ height: "95%" }}>
        <FullCalendar
          plugins={[timeGridPlugin]}
          initialView="timeGridWeek"

          headerToolbar={{
            left: "monthButtons,yearButtons",
            center: "title",
            right: "today,prev,next",
          }}
          customButtons={{
            monthButtons: {
              text: (
                <select
                  id="month"
                  className="form-select form-control form-control-sm me-2"
                  value={selectMonth}
                  onChange={(e) => {
                    handleMonthChange(e.target.value);
                  }}
                >
                  {getMonthNames().map((valor, index) => {
                    return (
                      <option key={index} value={valor.monthNumber}>
                        {valor.monthName}
                      </option>
                    );
                  })}
                </select>
              ),
            },
            yearButtons: {
              text: (
                <select
                  id="year"
                  className="form-select form-control form-control-sm"
                  value={selectYear}
                  onChange={(e) => {
                    handleYearChange(e.target.value);
                  }}
                >
                  {getYearsInRange().map((year, index) => (
                    <option key={index} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              ),
            },
          }}
          ref={calendarRef}
          initialDate={dateInitial}
          navLinks="true"
          firstDay="1"
          editable="true"
          selectable="false"
          unselectAuto="true"
          eventOverlap="false"
          eventColor="#f16621"
          slotDuration="00:30"
          allDaySlot={true}
          eventStartEditable="false"
          eventDurationEditable="false"
          slotLabelInterval="00:30"
          longPressDelay="0"
          nowIndicator="false"

          slotMinTime="07:00"
          slotMaxTime="20:45"
          visibleRange={{
            start: fechaCalendar.startRecur && fechaCalendar.startRecur,
            end: fechaCalendar.endRecur && fechaCalendar.endRecur,
          }}
          validRange={{
            start: fechaCalendar.startRecur && fechaCalendar.startRecur,
            end: fechaCalendar.endRecur && fechaCalendar.endRecur,
          }}
          events={listEventos}
          eventMouseEnter={handleMouseEnter}
          eventMouseLeave={handleMouseLeave}
          eventContent={(arg) => {
            return { html: arg.event.title };
          }}
          locale={idioma == "es" ? es : ""}
          datesSet={formatearFechaCabecera}
        />

        <button
          style={{ display: "none" }}
          data-bs-toggle="modal"
          data-bs-target="#errorCurso"
          id="modalErr"
        ></button>
      </div>
    );
  }
}
